import React from "react";
import Stack from "@mui/material/Stack";
import Typography, { TypographyProps } from "@mui/material/Typography";

// Custom.
import { RowProps } from "../global";

const Row: React.FC<RowProps> = (props) => {
  const { label, value, note, size = "normal" } = props;

  const RowTypography: React.FC<TypographyProps> = (props) => (
    <Typography
      variant={size === "small" ? "body1" : "h6"}
      fontWeight={size === "small" ? 400 : 600}
      {...props}
    />
  );

  return (
    <Stack
      alignItems="flex-start"
      spacing={1}
      direction="row"
      sx={(theme) => ({
        // alignItems: "flex-start",
        borderBottom: `1px solid ${theme.palette.grey[100]}`,
        // display: "flex",
        fontWeight: size === "small" ? 400 : 600,
        mb: 1,
        mt: 1.5,
        pb: 1.5,
        "&:last-of-type": {
          borderBottom: "none",
          pb: 0,
        },
      })}
    >
      {label && (
        <Stack sx={{ flex: 1 }} spacing={0}>
          <RowTypography>{label}</RowTypography>
          {note && (
            <>
              <Typography variant="caption" display="block">
                {note}
              </Typography>
            </>
          )}
        </Stack>
      )}
      {value && (
        <>
          {React.isValidElement(value) && value}
          {!React.isValidElement(value) && (
            <RowTypography>{value}</RowTypography>
          )}
        </>
      )}
    </Stack>
  );
};

export default Row;
